import React from 'react';
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

export const FileMultipleViewer = (props) => {
  const { value, onChange, meta } = props;

  const renderRequired = () => {
    if (meta && meta.required) {
      if (meta.classNAme === 'point') {
        return <div className='ico required'></div>;
      } else {
        return <span>*</span>;
      }
    }
  };

  return (
    <article className='form-file-multiple-viewer'>
      {meta.label && (
        <header>
          <span>{meta.label}</span>
          {renderRequired()}
        </header>
      )}

      <div className='file__box'>
        {value &&
          value.length > 0 &&
          value.map((item, index) => {
            const fileName = item ? item.split('/')[item.split('/').length - 1] : '';

            return (
              <Button
                onClick={() => {
                  window.open(item, '_blank');
                }}
                size='large'
                variant='outlined'
                endIcon={<FileDownloadIcon />}
              >
                {fileName}
              </Button>
            );
          })}
      </div>
    </article>
  );
};
